module.exports = __webpack_public_path__ + "static/img/14000104.80c51aa5.png";